import { z } from "zod";

/**
 * Advanced deployment settings (Twilio-specific variant)
 */
export const DeploymentAdvancedSettingsSchema = z.object({
  enableLogging: z.boolean().optional(),
  debugMode: z.boolean().optional(),
  timeoutSeconds: z.number().optional()
});

export type DeploymentAdvancedSettings = z.infer<typeof DeploymentAdvancedSettingsSchema>;
